import { render } from "./SkeletonLoading.vue?vue&type=template&id=0609fb44&scoped=true"
import script from "./SkeletonLoading.vue?vue&type=script&lang=js"
export * from "./SkeletonLoading.vue?vue&type=script&lang=js"

import "./SkeletonLoading.vue?vue&type=style&index=0&id=0609fb44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0609fb44"]])

export default __exports__